'use client';

import React from 'react';
import { SectionHeader } from '@/components/ui';
import Carousel from '@/components/carousel/Carousel';
import { CarouselControls } from '@/components/carousel/CarouselControls';
import { RecentBuildingSearchCard } from '@/components/cards/RecentBuildingSearchCard';
import { getRecentSearches, type RecentBuildingSearch } from '@/utils/recentSearches';
import { cn } from '@/lib/cn';

export function RecentBuildingSearches() {
  const [recentSearches, setRecentSearches] = React.useState<RecentBuildingSearch[]>([]);

  React.useEffect(() => {
    setRecentSearches(getRecentSearches().slice(0, 6));
  }, []);

  if (recentSearches.length === 0) {
    return null;
  }

  const carouselItems = recentSearches.map(search => ({
    id: search.buildingId,
    content: <RecentBuildingSearchCard search={search} />,
  }));

  return (
    <div className="dynamic-grid-container">
      <section className="section-container !gap-y-2">
        <div className="col-span-full flex items-center justify-between">
          <SectionHeader title="Recent searches" />
          {recentSearches.length > 4 && (
            <div className="hidden md:block pr-4">
              <CarouselControls carouselId="recent-building-searches" />
            </div>
          )}
        </div>

        <div className="col-span-full -mx-4 md:mx-0 md:px-1">
          <Carousel
            className={cn('w-full')}
            carouselId="recent-building-searches"
            items={carouselItems}
            // Slightly larger mobile inset so card shadows aren't clipped against the viewport edge
            // (this section uses `-mx-4` for full-bleed layout).
            padStart={{ mobile: 24, tablet: 12, desktop: 12 }}
            padEnd={{ mobile: 24, tablet: 12, desktop: 12 }}
            perView={{
              mobile: 1,
              tablet: 2,
              desktop: 4,
            }}
            peek={{
              mobile: 80,
              tablet: 0,
              desktop: 0,
            }}
            gap={16}
            ariaLabel="Recent building searches"
          />
        </div>
      </section>
    </div>
  );
}
